import React from 'react'
import BiDirectionCard from '../commons/BidirectionalCard'
import { StyleContentWrapper } from '../commons/ContentWrapper/style'

interface IbidirectionCard {
  marginTop?: string
  title1?: string
  subtitle1?: string
  imgSrc1?: string
  title2?: string
  subtitle2?: string
  imgSrc2?: string
}

const CoupleBidirectionCard = ({
  title1,
  subtitle1,
  imgSrc1,
  title2,
  subtitle2,
  imgSrc2,
}: IbidirectionCard) => {
  return (
    <StyleContentWrapper paddingLeft='50' paddingRight='50'>
      <BiDirectionCard
        marginTop="40"
        title={title1 || 'Book Lab Tests with Ease'}
        subtitle={
          subtitle1 ||
          `"Skip the clinic lines and schedule your lab tests from home. Choose your preferred time,
location, and get results delivered directly to your app - quick, secure, and hassle-free."`
        }
        imgSrc={imgSrc1 || '/servicesSvg/image3.svg'}
      />
      <BiDirectionCard
        direction="reverse"
        marginTop="40"
        title={title2 || 'Book Lab Tests with Ease'}
        subtitle={
          subtitle2 ||
          `"Skip the clinic lines and schedule your lab tests from home. Choose your preferred time,
location, and get results delivered directly to your app - quick, secure, and hassle-free."`
        }
        imgSrc={imgSrc2 || '/servicesSvg/image3.svg'}
      />
    </StyleContentWrapper>
  )
}

export default CoupleBidirectionCard
